module.exports = __webpack_public_path__ + "static/media/sy.6065fa16.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sy.svg
// module id = 948
// module chunks = 0